export var doc = {
    content: '(block|layoutSection)+',
    marks: 'alignment breakout indentation link',
};
//# sourceMappingURL=doc.js.map